import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import useStore from '@/store/useStore';
import { trackEvent, trackEventWithObject } from '@/utils/gaDataPush';
import { BeCountriesAndCurrencies } from '@/data/geCountries';

type foundCountry = {
  CountryCode: string;
  icon: string;
  CurrencyCode: string;
  CountryName: string;
  CultureProgId: string;
};

type Props = {
  isMobile?: boolean;
};

export default function LocalCountries({ isMobile }: Props) {
  const setIsGlobalEModalVisible = useStore(state => state.setIsGlobalEModalVisible);
  const { ipCountry, currCountry } = useStore(state => state.user);
  const selCountry = Cookies.get('sel_country');
  const [country, setCountry] = useState<foundCountry | null>(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    const path = window.location.pathname.split('/')[1];
    const pathCountryMap = {
      'en-us': 'US',
      'en-ca': 'CA',
      'en-au': 'AU',
      'en-gb': 'GB',
    };
    const selected = pathCountryMap[path] || selCountry || ipCountry || 'US';
    const foundCountry = BeCountriesAndCurrencies.find(c => c.CountryCode === selected) || {
      CountryCode: 'US',
      icon: '/bee2-ui/img/flags/us.png',
      CurrencyCode: 'USD',
      CountryName: 'United States',
      CultureProgId: 'en-GB',
    };

    setCountry(foundCountry);
  }, [selCountry, ipCountry]);

  return (
    <li
      style={{ cursor: 'pointer', display: 'inline-flex' }}
      className="has-ico tw-inline-flex local-gle tw-pointer-events-auto"
      aria-label="Change your shipping country and currency"
    >
      <a
        style={{ textDecoration: 'none' }}
        role="button"
        data-event1-category="Header"
        data-event1-action="Hover"
        data-event1-label="Currency Dropdown"
        data-noninteract="false"
        onMouseEnter={trackEvent}
        tabIndex={0}
        className="tw-inline-flex tw-items-stretch tw-h-[17px] focus:tw-outline-none focus-visible:tw-outline-[-webkit-focus-ring-color]"
        onClick={() => {
          setIsGlobalEModalVisible(true);
          trackEventWithObject({
            event: isMobile ? 'top_navigation' : 'header',
            general_event_category: 'Country Feature Flag',
            general_event_section: 'Main Icon',
            general_event_details: 'Undefined',
            affiliation: currCountry === 'united states' ? 'domestic' : 'international',
          });
        }}
      >
        {isClient && country && (
          <img
            id="ge_flag"
            src={country?.icon} // this should be stored locally
            style={{
              width: '17px',
              height: '17px',
              cursor: 'pointer',
              float: 'left',
              border: '1px solid gray',
              borderRadius: '17px',
            }}
            className="navitem -mr-2"
            alt="CountryFlag"
          />
        )}
        <span className="tw-ml-2 tw-hidden md:tw-inline tw-leading-tight">{country?.CurrencyCode}</span>
        <span className="tw-ml-[15px] md:tw-ml-2 tw-inline md:tw-hidden tw-leading-tight">
          {country?.CountryName?.toUpperCase()} ({country?.CurrencyCode})
        </span>
      </a>
    </li>
  );
}
